module.exports = __webpack_public_path__ + "static/media/Organization-Structure.57d26999.png";